<template>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
       viewBox="0 0 40 29" enable-background="new 0 0 40 29" xml:space="preserve">
<linearGradient id="brandGradient" gradientUnits="userSpaceOnUse" x1="-1829.2997" y1="38.4395" x2="-1830.2896" y2="38.4395" gradientTransform="matrix(-39.3625 0 0 -27.6775 -72005.4219 1078.658)">
	<template v-if="theme === 'truck'">
    <stop offset="0" style="stop-color:#2B9955"/>
    <stop offset="1" style="stop-color:#0D92CD"/>
  </template>
  <template v-else-if="theme === 'academy'">
    <stop offset="0" style="stop-color:#E3001D"/>
    <stop offset="1" style="stop-color:#FECE42"/>
  </template>
</linearGradient>
    <path fill="url(#brandGradient)" d="M12.9,28.2c0.5,0.6,1.4,0.6,2,0c0.5-0.5,0.5-1.4,0-2L4.8,16.1H38c0.8,0,1.4-0.6,1.4-1.4
	c0-0.8-0.6-1.4-1.4-1.4H4.7l10.1-10c0.5-0.6,0.5-1.4,0-2c-0.6-0.6-1.4-0.6-2,0L0.4,13.7c-0.6,0.5-0.6,1.4,0,2L12.9,28.2z"/>
</svg>

</template>

<script>
export default {
  name: "VIconArrowLeft",
  data () {
    return {

    }
  },

  props: {
    theme: {
      type: String,
      default: 'truck'
    }
  }
}
</script>

